<script lang="ts" context="module">
  const host = cva(
    'relative isolate w-full block rounded-md after:absolute after:inset-0 after:bg-primary/4 hover:after:bg-transparent after:rounded-md after:motion-safe:transition-colors',
    {
      variants: {
        size: {
          lg: 'h-[560px]',
          md: 'h-[208px] lg:h-[256px]'
        }
      }
    }
  );
  const text = cva(
    'text-center grid place-items-center z-10 pointer-events-none font-semibold text-highlight p-8 absolute inset-0 select-none',
    {
      variants: {
        size: {
          lg: 'text-5xl',
          md: 'text-3xl'
        }
      }
    }
  );
</script>

<script lang="ts">
  import CmsImage from '$components/cms-image.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { zoomOnScrollHandler } from '$lib/transitions';
  import { cn } from '$lib/utils';
  import { getAnchorFromCmsLink } from '$lib/utils/cms';
  import type { SingleCollectionCardStoryblok } from '$types/bloks';
  import { reducedMotion } from '@significa/svelte-toaster';
  import { cva, type VariantProps } from 'class-variance-authority';
  import { onMount } from 'svelte';

  export let block: SingleCollectionCardStoryblok;
  export let size: VariantProps<typeof host>['size'] = 'lg';

  $: ({ href, rel, target } = $getAnchorFromCmsLink(block.link));

  onMount(() => {
    if (block.slight_zoom_on_scroll && !$reducedMotion) {
      const handler = () => {
        zoomOnScrollHandler(container, (n) => (scale = n));
      };
      window.addEventListener('scroll', handler);
      return () => window.removeEventListener('scroll', handler);
    }
  });

  let container: HTMLElement;
  let scale = 1;
</script>

<a
  {href}
  {rel}
  {target}
  use:storyblokEditable={block}
  bind:this={container}
  class={cn(host({ size }))}
  style:--scale={scale}
>
  <div class="w-full h-full overflow-hidden rounded-md">
    <CmsImage
      image={block.image}
      options={{ size: [1440 * 2, 0] }}
      class="block object-cover w-full h-full rounded-md select-none pointer-events-none scale-[var(--scale)]"
    />
  </div>

  {#if block.title}
    <p class={cn(text({ size }))}>
      {block.title}
    </p>
  {/if}
</a>
